import { CSSProperties, SVGProps } from 'react';

type BaseIconProps = SVGProps<SVGSVGElement> & {
  size?: number | string;
};

export function BaseIcon({ children, color, size, style = {}, width, height, ...props }: BaseIconProps) {
  const computedSize = size || '1em';

  const styleProp: CSSProperties = {
    verticalAlign: 'middle',
    ...style,
  };

  const computedColor = color || style.color;
  if (computedColor) {
    styleProp.color = computedColor;
  }

  return (
    <svg
      fill="currentColor"
      preserveAspectRatio="xMidYMid meet"
      height={height || computedSize}
      width={width || computedSize}
      {...props}
      style={styleProp}
    >
      {children}
    </svg>
  );
}
